import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/beta-features")({
  component: () => <Outlet />,
});
